/* 
 * 21.02.2018
 * NewCatController ile birlikte CategoryAndFilters.js yerine kullanılır
 * Infinity Scroll yerine Paging yapısına uygundur
 * $(document).ready 'nin üstünde bulunan fonksiyonlar açılışta çağrılır
 * $(document).ready 'nin altında bulunan fonksiyonlar event'lara bağlıdır, $(document).ready 'deki click olaylarıyla tetiklenir
 */

var date = new Date();
date.setTime(date.getTime() + (5 * 60 * 1000));

function ToggleLeftBar() {
    if (!isMobileResolution()) {
        $(".FilterForm .filterLink").live("click", function () {
            $(".FilterForm .filterLink").not($(this)).removeClass("toggle-minus");
            $(".FilterForm .FilterBoxes").not($(this).parent().find(".FilterBoxes")).slideUp();

            $(this).toggleClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").slideToggle();
        });
    }
    else {
        $(".FilterForm .filterLink").live("click", function () {
            $(".FilterForm .filterLink").not($(this)).removeClass("toggle-minus");
            $(".FilterForm .FilterBoxes").not($(this).parent().find(".FilterBoxes")).removeClass("active");
            $(this).toggleClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").toggleClass("active");

        });
    }
}
function isMobileResolutions() {
    if ($(window).width() <= 991) {
        return true;
    }
    else {
        return false;
    }
}

function SetPriceSlider() {

    if ($(".CategoryLeftBar").length > 0 && ($("#PgType").val() == "Cat" || $("#PgType").val() == "Search")) {

        var slider = document.getElementById('PriceSlider');

        if (slider != null) {
            var min = $("#MinPrice").val();
            var max = $("#MaxPrice").val();
            var currencySymbol = $("#CurrencySymbol").val();

            noUiSlider.create(slider, {
                start: [min, max],
                connect: true,
                step: 1,
                range: {
                    'min': parseInt(min),
                    'max': parseInt(max)
                }
            });

            slider.noUiSlider.on('change', function () {
                var values = slider.noUiSlider.get();
                $("#MinPrice").val(Math.round(values[0]));
                $("#MaxPrice").val(Math.round(values[1]));
                $("#SliderValue").val(Math.round(values[0]) + "-" + Math.round(values[1]));

                if (!isMobileResolution()) {
                    //$(".AppylArea .FilterApplyButton").trigger("click");
                }
            });

            slider.noUiSlider.on('update', function () {
                var values = slider.noUiSlider.get();
                $("#MinPrice").val(Math.round(values[0]));
                $("#MaxPrice").val(Math.round(values[1]));
                $(".priceView").html("").html(Math.round(values[0]) + " " + currencySymbol + "<span style='padding: 0px 40px;'></span> " + Math.round(values[1]) + " " + currencySymbol);
            });
        }
        else {
            var currencySymbol = $("#CurrencySymbol").val();
            var min = $("#MinPrice").val();
            var max = $("#MaxPrice").val();
            $OldPriceValue = $("#SliderValue").val();

            $('#minPrc, #maxPrc').mask('00000', {
                translation: {
                    'Z': {
                        pattern: /[0-9]/, optional: false
                    }
                }
            });

            $(document).on("keyup", "#minPrc, #maxPrc", function () {
                var minPrc = $("#minPrc").val();
                var maxPrc = $("#maxPrc").val();

                //if (!minPrc) {
                //    minPrc = $("#MinPrice").val();
                //    $("#minPrc").val(minPrc);
                //}

                //if (!maxPrc) {
                //    maxPrc = $("#MaxPrice").val();
                //    $("#maxPrc").val(maxPrc);
                //}

                var sliderValue = minPrc + "-" + maxPrc;
                $("#SliderValue").val(sliderValue);

                setTimeout(function () {
                    var newSliderValue = $("#SliderValue").val();

                    if ($OldPriceValue != newSliderValue) {
                        //$(".AppylArea .FilterApplyButton").trigger("click");
                        $OldPriceValue = newSliderValue;
                    }

                }, 1000);

            });

        }
    }
}

function LazyLoad() {
    $(".ProductList .Prd img.PImage, .ProductList .Prd .ProductListColor img").Lazy();
}

// Cookie Değerine Göre Açılış Grid'ini Ayarlama Fonksiyonu
function SetGridByCookie() {
    var cookieGrid = $.cookie("OSgridCookie");
    if (cookieGrid == "" || cookieGrid == null || cookieGrid == undefined) {
        cookieGrid = "4";
        $.cookie("OSgridCookie", "4", { path: '/' }, { expires: 7 });
    }
    if (!isMobileResolution()) { // Desktop grid ayarlama
        DesktopGridSet(cookieGrid);
    }
    else { // Mobile grid ayarlama        
        MobileGridSet(cookieGrid);
    }
}

// Açılışta QueryString'deki Filtreleme Seçeneklerini Kontrol Eder
function QueryStringControlForFilter() {

    var vars = [], hash;
    var selectedSize = "";
    var selectedColor = "";
    var selectedCatalog = "";
    var selectedDepartment = "";
    var selectedSeason = "";
    var selectedPrice = "";
    var selectedSoldOut = "";
    var selectedSort = "";
    var selectedPropertie = "";
    var selectedCloth = "";
    var selectedBrand = "";
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder

    if (NativeQueryFilter.indexOf("=") != "-1") {

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "s") {
                selectedSize = hash[1]; // Size değerleri alınır
            }
            else if (hash[0] == "c") {
                selectedColor = hash[1]; // Color değerleri alınır
            }
            else if (hash[0] == "ct") {
                selectedCatalog = hash[1]; // katalog değerleri alınır
            }
            else if (hash[0] == "dp") {
                selectedDepartment = hash[1]; // Departman değerleri alınır
            }
            else if (hash[0] == "sea") {
                selectedSeason = hash[1]; // Departman değerleri alınır
            }
            else if (hash[0] == "b") {
                selectedBrand = hash[1]; // Marka değerini alınır
            }
            else if (hash[0] == "prc") {
                selectedPrice = hash[1]; // Price değerini alınır
            }
            else if (hash[0] == "so") {
                selectedSoldOut = hash[1]; // Tükenenleri Gizle seçeneğini alır
            }
            else if (hash[0] == "o") {
                selectedSort = hash[1]; // Sıralama seçeneği alınır
            }
            else if (hash[0] == "prp") {
                selectedPropertie = hash[1]; // Sıralama seçeneği alınır
            }
            else if (hash[0] == "clh") {
                selectedCloth = hash[1]; // Sıralama seçeneği alınır
            }
        }

        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedSize != null && selectedSize != "" && selectedSize != undefined) {
            var selectedSizes = selectedSize.split(',');

            $.each(selectedSizes, function (key, value) {
                $li = $("#Sizes li input[value='" + value + "']").prop("checked", true);
            });
        }
        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedColor != null && selectedColor != "" && selectedColor != undefined) {
            var selectedColors = selectedColor.split(',');

            $.each(selectedColors, function (key, value) {
                $li = $("#Colors li input[value='" + value + "']").prop("checked", true);
            });
        }
        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Katalog'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedCatalog != null && selectedCatalog != "" && selectedCatalog != undefined) {
            var selectedCatalogs = selectedCatalog.split(',');

            $.each(selectedCatalogs, function (key, value) {
                $li = $("#ProductGroup li input[value='" + value + "']").prop("checked", true);
            });
        }
        // Seçili Katalog'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Departman'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedDepartment != null && selectedDepartment != "" && selectedDepartment != undefined) {
            var selectedDepartments = selectedDepartment.split(',');

            $.each(selectedDepartments, function (key, value) {
                $li = $("#Departments li input[value='" + value + "']").prop("checked", true);
            });
        }
        // Seçili Departman'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Markaların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedBrand != null && selectedBrand != "" && selectedBrand != undefined) {
            var selectedBrands = selectedBrand.split(',');

            $.each(selectedBrands, function (key, value) {
                $li = $("#Brands li input[value='" + value + "']").prop("checked", true);
            });
        }
        // Seçili Markaların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Sezon'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedSeason != null && selectedSeason != "" && selectedSeason != undefined) {
            var selectedSeasons = selectedSeason.split(',');

            $.each(selectedSeasons, function (key, value) {
                $li = $("#Seasons li input[value='" + value + "']").prop("checked", true);
            });
        }
        // Seçili Sezon'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedPropertie != null && selectedPropertie != "" && selectedPropertie != undefined) {
            var selectedProperties = selectedPropertie.split(',');

            $.each(selectedProperties, function (key, value) {
                $li = $("#Properties li input[value='" + value + "']").prop("checked", true);
            });
        }
        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Kumaşların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedCloth != null && selectedCloth != "" && selectedCloth != undefined) {
            var selectedCloths = selectedCloth.split(',');

            $.each(selectedCloths, function (key, value) {
                $li = $("#Cloth li input[value='" + value + "']").prop("checked", true);
            });
        }
        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Price değer aralığını ayarlar
        if (selectedPrice != null && selectedPrice != "" && selectedPrice != undefined) {

            $("#SliderValue").val(selectedPrice);
            var SelectedPrices = selectedPrice.split('-');

            var slider = document.getElementById('PriceSlider');
            if (slider != null) {

                slider.noUiSlider.set([SelectedPrices[0], SelectedPrices[1]]);
            }
            else {
                $('#minPrc').val(SelectedPrices[0]);
                $('#maxPrc').val(SelectedPrices[1]);
            }

        }
        // Seçili Price değer aralığını ayarlar

        // Seçiliyse tükenenleri gizle seçeneğini işaretler
        if (selectedSoldOut != null && selectedSoldOut != "" && selectedSoldOut != undefined && selectedSoldOut == "1") {
            $li = $("#SoldOutOp li.gr");
            $li.find("input").attr("checked", "checked");
            $li.find("input").val("1");
            $li.find("label").addClass("checked2");
        }
        // Seçiliyse tükenenleri gizle seçeneğini işaretler

        // Sıralama varsa dropdown'dan seçeneği işaretler
        if (selectedSort != null && selectedSort != "" && selectedSort != undefined) {

            $li = $("#PrdSort input[value='" + selectedSort + "']").parent("li");

            if (isMobileResolution()) {
                $li = $("#PrdSortMobile input[value='" + selectedSort + "']").parent("li");
            }

            $li.find("label").addClass("checked");
            $li.find("label").addClass("c_on");

            $(".fLinkSortNo").html($li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir      
        }
        // Sıralama varsa dropdown'dan seçeneği işaretler

        $(".AppylArea .FilterApplyButton").trigger("click");
    }

    GetSelectedFilter(); // Gelen filtreleri Seçili Filtreler alanına ekler
}

// Seçimleriniz alanını footer'da gizler
function HideChoices() {
    $(window).scroll(function (event) {
        var y = $(this).scrollTop();
        var height = 0;

        $(".FilterForm .col-md-24").not(".AppylArea").each(function () {
            height += $(this).height();
        });

        height = height - 700;

        if (y >= height) {
            $(".AppylArea").removeClass("AppylAreaFixed");

        } else {
            $(".AppylArea").addClass("AppylAreaFixed");
        }
    });
}

// Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
function BackButtonLastScroll() {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var browserName = navigator.userAgent;
    if (browserName.indexOf("Chrome")) {
        browserName = "Chrome";
    }

    var pgType = $("#PgType").val();
    var lastScrollTop = $.cookie("lastScroll");
    var CatID = $("#PID").val();
    var lastScrollTopFirst = $.cookie("getLastScrollFirst");

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

    if (pgType == "Cat") {

        if (CatID != $.cookie("lastCatalogID")) {
            lastScrollTopFirst = 0;
            $.cookie("lastCatalogID", CatID, { path: '/', expires: date });
        }

        if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
            if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {

                var listHeight = $(".ProductList").height();
                lastScrollTop = lastScrollTop - (listHeight /** (currentPage - 1)*/);

                if (lastScrollTop > 0) {
                    $('html, body').animate({
                        scrollTop: lastScrollTop
                    }, 0);
                }
            }
        }

        //if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
        //    if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTop
        //            }, 0);
        //        }, 1000);
        //    }
        //}
        //else {

        //    if (lastScrollTopFirst != null && lastScrollTopFirst != "" && lastScrollTopFirst != undefined && lastScrollTopFirst > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTopFirst
        //            }, 0);
        //        }, 1000);
        //    }
        //}

        $.cookie("getLastScrollFirst", "0", { path: '/', expires: date });
        $.cookie("lastScroll", "0", { path: '/', expires: date });
    }
}

function getPenPath() {
    var vars = [], hash;
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder
    var currentPage = 1;

    if (NativeQueryFilter.indexOf("=") != "-1") {
        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                currentPage = hash[1];
            }
        }
    }

    var params = GenerateParams("paging", (parseInt(currentPage) + 1) /*this.loadCount + 2*/); // Sayfalama için istek parametresi üretir
    if (params) {
        //return "/" + $("#SmallLangCode").val() + "/p/Home/GetProductList?" + params;
        return "?" + params;
    }
}

function InfinityScroll() {
    var $container = $('.ProductList').infiniteScroll({
        path: getPenPath,
        append: '.Prd',
        scrollThreshold: 500,
        checkLastPage: ".pageEnd"
    });
    var infScroll = $container.data('infiniteScroll');

    $container.on('load.infiniteScroll', function () {
        setTimeout(function () {
            LazyLoad();

            var cookieGrid = $.cookie("OSgridCookie");
            if (isMobileResolution()) {
                MobileGridSet(cookieGrid);
            }
            else {
                DesktopGridSet(cookieGrid);
            }
        }, 2000);
    });
}

function IsFollowCategory() {
    if ($(".ProductList .Prd .QuickLookLikeBtn").length <= 0) {
        return;
    }

    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/ProductDetails/IsFollowAll",
        dataType: 'json',
        async: true,
        success: function (dt) {
            updateList(dt);
        }
    });

    var updateList = function (dt) {
        $(".ProductList .Prd .QuickLookLikeBtn").removeClass("active");

        for (var i in dt) {
            var item = dt[i];

            var followlar = $(".ProductList .Prd .QuickLookLikeBtn").filter(function (index) {
                return $(this).attr("data-id") == item["ProductID"] && $(this).attr("data-colorid") == item["ColorID"];
            });

            if (followlar.length > 0) {
                var followItem = $(followlar[0]);
                followItem.addClass("active");
                followItem.find(".sorsfont").removeClass("sorsfont-Star").addClass("sorsfont-Star-fill");

                //if (followItem.hasClass("active")) {
                //    followItem.children("img").attr("src", "/Images/OXNW/like_full.svg");
                //}
                followItem.children("img").attr("src", "/Images/OS/Heart_black.svg");
            }
        }
    };
}

function FollowProperty() {
    $(document).on("click", ".QuickLookLikeBtn:not(.active)", function () {
        var ProductID = $($(this)).attr("data-id");
        var ColorID = $($(this)).attr("data-colorid");
        button = $(this);
        GenerateLocalLoading(button.closest(".Prd"), "show");
        console.log(ProductID);
        console.log(ColorID);
        AddToFavorite(ColorID, ProductID, function (result, msg) {
            if (result == true) {
                button.addClass("active");
                button.find(".sorsfont").removeClass("sorsfont-Star").addClass("sorsfont-Star-fill");

                button.find(".heart-icon").attr("src", "/images/OS/Heart_black.svg");
            }
            else {
                //SwalGenerate("error", msg, getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));

                var loginLink = getRequestRoute() + "/p/User/Login";

                SwalGenerate("warning", msg, "Favorilere Eklenemedi", "<a class='loginbtn'>" + getStandartMessages("GirisYap") + "</a>");
            }

            GenerateLocalLoading(button.closest(".Prd"), "hide");
        });
    });

    $(document).on("click", ".QuickLookLikeBtn.active", function () {
        var ProductID = $($(this)).attr("data-id");
        button = $(this);
        GenerateLocalLoading(button.closest(".Prd"), "show");

        removeFavorite(ProductID, function (result) {
            if (result == true) {
                button.removeClass("active");
                button.find(".sorsfont").removeClass("sorsfont-Star-fill").addClass("sorsfont-Star");

                button.find(".heart-icon").attr("src", "/images/OS/Heart.svg");
            }
            else {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            }

            GenerateLocalLoading(button.closest(".Prd"), "hide");
        });
    });
}

//ürün listesi açılır açılmaz datalayera push yapacak script (view_item_list)
function ScrollAllGetProduct() {
    var productList = $(".contentTopSpace .ProductColumn .PrdContainer .Products .ProductList");
    if (productList.length > 0) {
        var products = productList.find(".PrdItemBox");
        var productListAll = [];

        products.each(function (index, element) {
            var ProductCode = $(this).attr("data-productcode");
            var ProductName = $(this).attr("data-productname");
            var ColorName = $(this).attr("data-colorname");
            var price = parseFloat($(this).attr("data-amount"));
            var priceOld = parseFloat($(this).attr("data-amountPsf"));
            var discount = $(this).attr("data-discount");
            var dataProductListPosition = $(this).attr("data-listposition");
            var category1 = $(this).attr('data-category1');
            var category2 = $(this).attr('data-category2');
            var category3 = $(this).attr('data-category3');
            var catID = $(this).attr('data-catID');
            var itemListName = $(this).attr('data-itemListName');


            discount = priceOld - price;
            if (price == priceOld) {
                discount = 0;
            }

            var amount = price;
            if (amount == 0) {
                amount = priceOld;
            }

            var value = parseFloat(amount);


            var viewItem = {
                item_id: ProductCode,
                item_name: ProductName,
                affiliation: category1,
                coupon: "",
                currency: 'TRY',
                discount: discount,
                index: parseInt(dataProductListPosition),
                item_brand: 'OS',
                item_category: category1,
                item_category2: category2,
                item_category3: category3,
                item_list_id: parseInt(catID),
                item_list_name: itemListName,
                item_variant: ColorName,
                location_id: 'İST',
                price: priceOld,
                quantity: 1
            };

            productListAll.push(viewItem);
        });

        // Mevcut catID'yi kaydet
        if (productListAll.length > 0) {
            var currentCatID = productListAll[0].item_list_id;
            localStorage.setItem('lastViewedCatID', currentCatID);
            var currentItemListName = productListAll[0].item_list_name;
            localStorage.setItem('lastViewedItemListName', currentItemListName);
        }

        // Tüm ürünleri aktarır
        dataLayer.push({
            event: "view_item_list",
            ecommerce: {
                items: productListAll
            }
        });
    }

}



$(document).ready(function () {
    var PageType = $("#PgType").val();

    if (PageType == "Cat" || PageType == "Combine" || PageType == "Search" || PageType == "Brand") {

        var InfinityScroll = $("#IsInfinity").val();

        if (InfinityScroll == "True") {
            $container = $('.ProductList').infiniteScroll({
                path: getPenPath,
                append: '.Prd',
                scrollThreshold: 500,
                checkLastPage: ".pageEnd"
            });
            var infScroll = $container.data('infiniteScroll');

            $container.on('load.infiniteScroll', function () {
                setTimeout(function () {
                    LazyLoad();

                    var cookieGrid = $.cookie("OSgridCookie");
                    if (isMobileResolution()) {
                        MobileGridSet(cookieGrid);
                    }
                    else {
                        DesktopGridSet(cookieGrid);
                    }
                }, 1000);
            });

            BackButtonLastScroll();
        }
        else {
            BackButtonLastScroll(); // Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
        }

        // Left/Filter Bar
        ToggleLeftBar();
        SetPriceSlider();
        ScrollAllGetProduct();
        LazyLoad(); // Lazy Load    
        SetGridByCookie(); // Cookie Değerine Göre Grid Ayarlama
        ClearAllFilter("false");
        QueryStringControlForFilter(); // QueryString'deki filtreleri kontrol eder

        if (!isMobileResolution()) {
            filterPriceTrigger();
        }

        if (!isMobileResolution()) {
            $(document).on("click", "#LeftWrapper .FilterBoxes:not(.Sorts) li > label", function () {
                //$(".AppylArea .FilterApplyButton").trigger("click");
            });

            var FilterAreaHeight = $(window).height() - $("header").height() - 20;
            $("#LeftWrapper").css("height", FilterAreaHeight + "px");

            $(window).resize(function () {
                setTimeout(function () {
                    var FilterAreaHeight = $(window).height() - $("header").height() - 20;
                    $("#LeftWrapper").css("height", FilterAreaHeight + "px");
                }, 500);
            });
        }
        else {
            $(document).on("click", "#LeftWrapper .FilterArea .mobilFilterArea .MobilFilterHeader .close-filter", function () {
                toggleMenusOperation("all");
            });

            // Mobil filtre geri kaydırma
            $(document).on("click", ".FilterForm .FilterBoxes .MobileFilterHeader a", function () {
                $(this).parents(".FilterOption").removeClass("active");
                $(this).parents(".col-md-24").children(".filterLink").addClass("toggle-minus");
            });
        }

        BrowserBackAndPrevButtonControl(); // Browser iler/geri tuşları tetiklenince çalışır
        IsFollowCategory();
        FollowProperty();

        if ($(".ProductList.NotFoundContainer .NotFound").length > 0) {
            var LastVisitedPrds = GetLastVisitedData();

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
                GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
                    if (dt != "") {
                        $(".ProductList.NotFoundContainer .SuggestedProductsContainer .AutoGetLastVisited").append(dt);
                        //SlickSlider("suggested");
                        LazyLoad();
                    }
                });
            }
        }
    }

    // Ürünler
    $(document).on("click", ".ProductList .Prd .AddToCartArea button.AddToCart", function () {
        $basketButton = $(this);
        var SizeID = $basketButton.attr("data-sizeid");
        var ColorID = $basketButton.attr("data-colorid");
        var ProductID = $basketButton.attr("data-productid");
        var LangID = $("#SmallLangCode").val();

        if (!$basketButton.hasClass("passive")) {
            if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "" && SizeID != "0" && ColorID != "0" && ProductID != "0") {
                var param = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + 1 + "&langID=" + LangID;

                GenerateLocalLoading($basketButton.parents(".Prd"), "show");
                AddToCard(param, function (dt) {

                    if (dt.Sonuc == true) {
                        GetSepetIcerik(function (dt) {
                            setTimeout(function () {
                                $basketButton.closest("div.AddToCartArea").children(".TransformContainer").removeClass("select-size");
                            }, 500);

                            $("#UserAndBasket").html(dt);
                            $(".SepetProducts .BasketContainer .CartTitle .basket-text").html(getAddBasketMessage($(".SepetProducts .BasketContainer .Center .BasketCenterContent .SepetRow").length));
                            if ($(window).width() > 991) {
                                toggleMenusOperation("basket");
                            }

                            generateToolTip();

                            GenerateLocalLoading($basketButton.parents(".Prd"), "hide");
                        });
                    }
                    else {
                        SwalGenerate("error", dt.IslemSonucAciklama, "İşlemin Başarısız", "Kapat");
                        GenerateLocalLoading($basketButton.parents(".Prd"), "hide");
                    }
                });
            }
            else if (SizeID === "0" && $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html() === "") {
                var params = "ColorID=" + ColorID + "&ProductID=" + ProductID;
                GetSizeOfColor(params);
            }
        }

        return false;
    });


    $('.ProductListSizeContainer div.ProductListSize:not(.passive)').live("click", function () {
        var $currentColor = $(this);
        var sizeID = $(this).attr("data-size");

        $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", sizeID);
        $currentColor.closest(".ProductListSizeContainer").find(".ProductListSize").removeClass("active");
        $currentColor.addClass("active");
        $currentColor.closest(".Prd").find(".AddToCart").click();
    });

    $(".ProductList .Prd").live({
        mouseleave:
            function () {
                $(this).find(".AddToCartArea .TransformContainer").removeClass("select-size");
                //$(this).find(".AddToCartArea .TransformContainer .button-container .AddToCart").removeClass("passive");
                $(this).find(".AddToCartArea .ProductListSizeContainer").html("");
            }
    });

    $('.ProductListColorContainer div.ProductListColor:not(.passive)').live("click", function () {
        var $currentColor = $(this);

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var item_unique_id = $(this).attr("data-item-unique-id");
        var sizeID = $(this).attr("data-size");
        var params = "ColorID=" + colorID + "&ProductID=" + productID;

        if (typeof sizeID === "undefined") {
            sizeID = 0;

            $detailLinks = $(this).closest(".Prd").find("a");
            $currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");
            $currentColor.addClass("active");

            GetImageOfColors(params, item_unique_id, $currentColor);

            $currentColor.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html("");
            $currentColor.closest(".AddToCartArea").find(".TransformContainer").removeClass("select-size");
        }
    });

    $('.ProductList .Prd').live("click", function (e) {
        var ScrollContentID = "LastScrollTop" + $("#PID").val();
        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });
    });

    //if (isMobile(true)) {
    //    if ($("div.row.Products").length > 0) {
    //        var ScrollSize = +70;
    //        var offsetTop = 0;

    //        ScrollSize = 50;
    //        offsetTop = $(".BreadCrumbArea:first").offset().top;

    //        $('html, body').animate({
    //            scrollTop: offsetTop - ScrollSize
    //        }, 500);
    //    }
    //}
    // End Ürünler

    // Renk ve Beden Filteri
    $('#Colors > li > input, #Sizes > li > input, #Properties > li > input, #Cloth > li > input, #ProductGroup > li > input, #Departments > li > input, #Seasons > li > input, #Brands > li > input').live('change', function (event) {
        if (!isMobileResolution()) {
            $(".AppylArea .FilterApplyButton").trigger("click");
        }
    });

    // Seçili Filtreler Alanındaki Filteri Kaldırma
    $(".SelectedFilterCancelIcon").live("click", function () {
        var selectedVal = $(this).attr("data-value");
        var selectedType = $(this).attr("data-type");

        ClearSelectedFilter(selectedVal, selectedType);
    });

    // Tüm Filtreleri Kaldırır
    $(".SelectedFilter .ClearAllFilter").live("click", function () {
        ClearAllFilter("true");
    });

    // Tükenenleri Gizle
    $('#SoldOutOp > li.gr input').click(function (event) {
        SoldOutFilter($(this));
    });

    // Sıralama
    //$('#PrdSort > li, #PrdSortMobile > li').click(function (event) {
    //    ProductSort($(this));
    //});

    $(document).on("click", "#PrdSort > li, #PrdSortMobile > li", function () {
        ProductSort($(this));
    });

    // Desktop Grid Seçimi
    $(".mGridIcons-2, .mGridIcons-3, .mGridIcons-4").click(function () {
        var gridID = $(this).attr("data-gridvalue");
        if (gridID != null && gridID != undefined && gridID != "") {
            DesktopGridSet(gridID);
        }
    });

    // Mobile Grid Seçimi
    $(".gridAyarla").click(function () {
        if (isMobileResolution()) {
            var gridID = $(this).attr("data-grid");
            cookieGrid = $.cookie("OSgridCookie");

            if (gridID != null && gridID != undefined && gridID != "") {
                MobileGridSet(gridID);
                $.cookie("OSgridCookie", gridID, { path: '/' });
            }
        }
    });

    // Yeni Açının Çağrılması
    $(document).on("slid.bs.carousel", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        var ImageSrc = $(this).find(".carousel-item.active").find("img").attr("src");
        $nextOrPrevImage = $(this).find(".carousel-item.active").find("img");

        if (ImageSrc != undefined && ImageSrc.indexOf("lazy_back_new.gif") != -1) {
            $nextOrPrevImage.attr("src", $nextOrPrevImage.attr("data-img"));
        }
    });

    $(document).on("swiperight", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        $(this).carousel('prev');
    });

    $(document).on("swipeleft", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        $(this).carousel('next');
    });

    // Paging İsteği
    $(".Pages a, #nextPage a").live("click", function () {
        var pageNo = $(this).attr("data-pgno");
        if ($(this).parent().hasClass("sold") == false) {
            $.cookie("lastScroll", 0, { path: '/', expires: date });
            $.cookie("getLastScrollFirst", 0, { path: '/', expires: date });

            if (pageNo != null && pageNo != undefined && pageNo != "") {

                if ($(this).parent().hasClass("first")) {
                    getPageByPageNo(1, "true");
                } else {
                    getPageByPageNo(pageNo, "false");
                }
            }
        }

    });

    // Ürün'e Tıklandığında Scroll Position Alınır
    $(".ProductList a img:not(.NextPageImg)").live("click", function () {
        var lastScroll = $(window).scrollTop();
        var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

        if (NativeQueryFilter.indexOf("=") != "-1") {
            $.cookie("lastScroll", lastScroll, { path: '/', expires: date });
        }
        else {
            $.cookie("getLastScrollFirst", lastScroll, { path: '/', expires: date });
        }
    });

    // Filtreleme İsteği
    $(".AppylArea .FilterApplyButton").live("click", function () {
        GetPageByFilter();

        if (isMobileResolution) {
            toggleMenusOperation("all");
        }

    });

    $(".AppylArea .FilterClearButton").live("click", function () {
        ClearAllFilter("true");
    });
    $(".AppylArea .FilterCloseButton").live("click", function () {
        toggleMenusOperation("all");
    });


    // Kategori Açıklama Yazısını Gösterir
    $('.CatShowMore, .CatShowLess').on('click', function (e, index) {
        var Clicked = $(this).attr("class");
        CatDescShowOrHide(Clicked);
    });

    // Mobil İçin Filtre ve Sıralama Alanını Açar
    $(".OpenFilterOrSortArea").click(function () {
        var area = $(this).parent().hasClass("FilterDiv"); // Tıklanan butonun filtre mi sıralama mı olduğuna mı bakılıyor

        if (area == true) {
            //MobilSortFilterAreaOpenOrClose(".mobilFilterArea");
            toggleMenusOperation("mobileFilter");
        }
        else {
            //MobilSortFilterAreaOpenOrClose(".MobilSortArea");
        }
    });

    // Filter Search
    $(document).on("keyup", ".SearchInList .SearchFilter", function () {
        var input, filter, txtValue, li;
        input = $(this).val().toUpperCase();
        filter = input.toLocaleLowerCase();
        li = $(this).parents(".First").find(".FilterOption > ul > li");

        li.each(function (index) {
            txtValue = $(this).find("input[type='checkbox']").first().attr("data-rel");

            if (txtValue.toLocaleLowerCase().indexOf(filter) > -1) {
                $(this).css("display", "block");
            } else {
                $(this).css("display", "none");
            }
        });
    });
});


// Kategori Açıklama Yazısını Açıp/Kapatır
function CatDescShowOrHide($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "CatShowMore") {
            $(".CatShowMore").hide();
            $('.CatShowLess').show();
            $('.CatSecondPart').show();
            $('.CatShortPart').hide();
        }
        else {
            $(".CatShowLess").hide();
            $('.CatShowMore').show();
            $('.CatSecondPart').hide();
            $('.CatShortPart').show();
        }
    }
}


function filterPriceTrigger() {
    $(document).on("click", ".js-price-filter-button", function () {
        $(".AppylArea .FilterApplyButton").trigger("click");
    });
}

// Seçili Filtre Alanını Açıp/Kapatan Fonksiyon (Up/Down değeri alır)
function OpenCloseSelectedFilterArea($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "Up") {
            $(".SelectedFilterBody").slideDown("slow");
            $(".SelectedFilter .SelectedFilterBody").removeClass("closed");
            $(".SelectedFilter").show();
        }
        else if ($event == "Down") {
            $(".SelectedFilterBody").slideUp("slow");
            $(".SelectedFilter .SelectedFilterBody").addClass("closed");
            $(".SelectedFilter").hide();
        }
    }
}

// Tükenenleri Gizle Seçeneğini Kontrol Eden Fonksiyon
function SoldOutFilter($soldOut) {

    $li = $soldOut.parent();

    if ($li.find("input").val() == "0") {
        $li.find("label").addClass("checked2");
        $li.find("input").val("1");
        //GetPageByFilter();
    }
    else {
        $li.find("label").removeClass("checked2");
        $li.find("input").val("0");

        var currentPage = $(".Pages a.selected").attr("data-pgno");
        getPageByPageNo(currentPage, "false");
    }

}

// Sıralama Seçeneğini Kontrol Eden Fonksiyon
function ProductSort(selectedSort) {
    var li = selectedSort;

    // Tüm seçenekleri kapatır
    $("#PrdSort input, #PrdSortMobile input").removeAttr("checked");
    $("#PrdSort label, #PrdSortMobile label").removeClass("checked");
    $("#PrdSort label, #PrdSortMobile label").removeClass("c_on");

    // Kullanıcının istediği seçeneği seçili yapar
    li.find("label").addClass("checked");
    li.find("label").addClass("c_on");

    // Sıralama ekranını kapatır
    $(".fLinkSortNo").removeClass("toggle-minus");
    $("#PrdSort").parent().hide();

    $(".fLinkSortNo").html("<i class='sorsfont sorsfont-slide-bar'></i>" + li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir

    //if (!isMobileResolutions) {
    //    alert("burası çokomelli");
    //}



    var currentPage = "1";

    //if ($("#IsInfinity").val() == "False") {
    //    if ($(".Pages a.selected").length > 0) {
    //        currentPage = $(".Pages a.selected").attr("data-pgno"); // Kullanıcının bulunduğu sayfa alınır
    //    }
    //    else {
    //        currentPage = 1;
    //    }
    //}

    //getPageByPageNo(currentPage, "false");

    if (!isMobileResolution()) {
        getPageByPageNo(currentPage, "false");
    }

    //if (isMobileResolution()) {
    //    MobilSortFilterAreaOpenOrClose(".MobilSortArea");
    //}
}

// Desktop Grid Seçim Fonksiyonu
function DesktopGridSet($gridSize) {

    var removeClass = "";
    var addClass = "";
    var ActiveIcons = "";
    var PasiveIcons = "";
    var AddToCartAreaWidth = "";
    var gridValue = "";
    var selectedGridClass = "";
    var deSelectedGridClass = "";
    var PageType = $("#PgType").val();

    if ($gridSize == "4") {
        removeClass = "triple";
        addClass = "";
        ActiveIcons = "grid-color";
        PasiveIcons = "sorsfont-4-grid";
        AddToCartAreaWidth = "92%";
        gridValue = "4";
        selectedGridClass = ".mGridIcons-" + gridValue;
        deSelectedGridClass = ".mGridIcons-3";
        deSelectedRemoveIcons = "grid-color";
        deSelectedAddIcons = "sorsfont-3-grid";
    }
    else {
        removeClass = "";
        addClass = "triple";
        ActiveIcons = "grid-color";
        PasiveIcons = "sorsfont-3-grid";
        AddToCartAreaWidth = "96%";
        gridValue = "3";
        selectedGridClass = ".mGridIcons-" + gridValue;
        deSelectedGridClass = ".mGridIcons-4";
        deSelectedRemoveIcons = "grid-color";
        deSelectedAddIcons = "sorsfont-4-grid";
    }


    if (PageType != null && PageType != "" && PageType != undefined && PageType != "Combine") {
        $(".PrdContainer .ProductList").removeClass(removeClass).addClass(addClass);

        $(selectedGridClass).find(".sorsfont ").addClass(ActiveIcons).removeClass(PasiveIcons);
        $(deSelectedGridClass).find(".sorsfont ").removeClass(deSelectedRemoveIcons).addClass(deSelectedAddIcons);
    }
    else if (PageType != "Combine") {
        //$(".PrdContainer .ProductList .Prd").addClass("col-lg-8 col-xl-8");
    }

    $.cookie("OSgridCookie", gridValue, { path: '/' });
}

// Mobile Grid Seçim Fonksiyonu
function MobileGridSet($gridSize) {
    $(".gridAyarla i").removeClass("grid-color");

    if ($gridSize == "2" || $gridSize == "4") {
        $(".PrdContainer .ProductList").removeClass("triple");
        //$(".PrdContainer .ProductList .Prd .carousel .carousel-indicators").css("left", "75%");
        $(".gridAyarla.grid2 i").addClass("grid-color");
    }
    else {
        $(".PrdContainer .ProductList").addClass("triple");
        //$(".PrdContainer .ProductList .Prd .carousel .carousel-indicators").css("left", "85%");
        $(".gridAyarla.grid1 i").addClass("grid-color");
    }
}

// Filtreleme Ve Sayfa Geçişlerinde Loader Gösterip Gizler
function ShowOrHideBackDrop($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "show") {
            $(".backdrop").addClass("ShowBackdrop");
            $(".LoadingGif").show();
        }
        else if ($event == "hide") {
            $(".backdrop").removeClass("ShowBackdrop");
            $(".LoadingGif").hide();
        }
    }
}

// Paging İçin Ajax
function getPageByPageNo($pageNo, $IsBack) {
    if ($pageNo != null && $pageNo != "" && $pageNo != undefined && $pageNo != "0") {

        if ($IsBack != null && $IsBack != "" && $IsBack != undefined && $IsBack == "false") {
            GenerateUrlHistoy(); // URL History oluşturur
        }

        ShowOrHideBackDrop("show"); // Loader gösterilir

        var newScrollPosition = $(".Products").position(); // Filtreleme&Sayfalama işleminden sonra scroll'un gideceği position değeri
        if ($IsBack == "false") {
            $('html, body').animate({ // Listenin başına döndürür
                scrollTop: 0 //newScrollPosition.top
            }, 0);
        }

        var params = GenerateParams("paging", $pageNo); // Sayfalama için istek parametresi üretir

        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/Home/GetProductList",
            data: params,
            cache: false,
            success: function (data) {

                ShowOrHideBackDrop("hide"); // Loader kapatılır
                toggleMenusOperation("all");
                SetUrl(params);
                if ($(".ProductList .NotFound").length <= 0) {
                    var IsInfinity = $("#IsInfinity").val();

                    if (IsInfinity == "True") {
                        $container.infiniteScroll('destroy');
                        $(".Products").html(data);
                        InfinityScroll();
                        LazyLoad();
                    }
                    else {
                        $(".Products").html(data);
                        LazyLoad();
                    }

                    IsFollowCategory();
                }

                var cookieGrid = $.cookie("OSgridCookie");
                if (isMobileResolution()) {
                    MobileGridSet(cookieGrid);
                }
                else {
                    DesktopGridSet(cookieGrid);
                }

                //#region InsiderObject
                var InsiderObjectBegin = data.indexOf("<!--InsiderObject-") + "<!--InsiderObject-".length;
                var InsiderObjectEnd = data.indexOf("-InsiderObject-->") - "-InsiderObject-->".length;

                var InsiderObjectCode = data.substr(InsiderObjectBegin, InsiderObjectEnd).replace("-InsiderObject-->", "").replace("<!--InsiderObject-", "");

                if (InsiderObjectCode != undefined && InsiderObjectCode.length > 0) {
                    window.insider_object = JSON.parse(InsiderObjectCode);
                }

                data = data.replace(InsiderObjectCode, "").replace("-InsiderObject-->", "").replace("<!--InsiderObject-", "");
                //#endregion InsiderObject

            },
            error: function () {
                ShowOrHideBackDrop("hide"); // Loader kapatılır
            }
        });

    }
}

// Filter İçin Ajax
function GetPageByFilter() {
    $('html, body').animate({
        scrollTop: 0
    }, 0);

    var loadingArea = $("body");
    var params = GenerateParams("filter"); // Filtreleme için istek parametresi üretir
    var reqUrl = "/p/Home/GetProductList";

    if ($("#PgType").val() == "Brand") {
        reqUrl = "/p/Brands/Products";
    }
    $.ajax({
        type: "GET",
        url: getRequestRoute() + reqUrl,
        data: params,
        beforeSend: function () {
            GenerateLocalLoading(loadingArea, "show");
        },
        cache: false,
        success: function (data) {

            var filteredProductIdsValue = $("#filteredProductIds").val();
            filteredParams = params + "&pIds=" + filteredProductIdsValue;

            var filteredProductIdsForPriceFilterValue = "-1";
            $(data).each(function (index, element) {
                if ($(element).attr('id') === 'filteredProductIdsForPriceFilter') {
                    filteredProductIdsForPriceFilterValue = $(element).val();
                }
            });

            filteredParams = filteredParams + "&pIdsForPriceFilter=" + filteredProductIdsForPriceFilterValue;

            GetFilteredFilter(filteredParams, function (dt) {
                $(".CategoryLeftBar .FilterArea .mobilFilterArea .MobilFilterBody").html(dt);
                GetSelectedFilter();

               SetUrl(params);

                $(".Products").html(data);
                LazyLoad();
                IsFollowCategory();

                if ($("#IsInfinity").val() == "True") {
                    $container.infiniteScroll('destroy');
                    InfinityScroll();
                }

                if ($("#PgType").val() == "Search") {
                    if (data.includes("NotFoundContainer")) {
                        $("#MainNavBrd").addClass("d-none");
                    }
                    else {
                        $("#MainNavBrd").removeClass("d-none");
                        $("#MainNavBrd h1 span").html($("#ProductCountTotal").text());
                    }
                }

                if ($(".SuggestedProductsContainer").length > 0) {
                    SetLastVisitedProductsStorage();
                }

                var cookieGrid = $.cookie("OSgridCookie");

                if (isMobileResolution()) {
                    $(".backdrop").removeClass("rightMenu");
                    MobileGridSet(cookieGrid);

                    if ($("#LeftWrapper .mobilFilterArea .FilterBoxes").hasClass("active")) {
                        var ActiveBox = $("#LeftWrapper .mobilFilterArea .FilterBoxes.active");
                        ActiveBox.removeClass("active");
                        ActiveBox.parent().children(".filterLink").addClass("toggle-minus");
                    }
                    else {
                        toggleMenusOperation("all");
                    }
                }
                else {
                    DesktopGridSet(cookieGrid);
                    toggleMenusOperation("all");
                }

                GenerateLocalLoading(loadingArea, "hide");
            });
        },
        error: function () {
            GenerateLocalLoading(loadingArea, "hide");
        }
    });
}

// Filtreleme Ve Sayfalama İsteklerinde Parametre Oluşturur
function GenerateParams($action, $pageNo) {
    var params = "";

    if ($action != null && $action != "" && $action != undefined) {

        // Sayfa Numarasını Ayarlar
        if ($action == "paging") {
            params = "p=" + $pageNo;
        }
        else if ($action == "filter") {
            params = "p=1";
        }
        // Sayfa Numarasını Ayarlar

        var CatalogPart = ""; // Catalog ID'sini alır

        if ($("#PgType").val() == "Search") { // Search ise catalog ID yerine sr parametresini alır
            CatalogPart = "&sr=" + $("#PID").val();

            if ($("#ProductGroup input[type='checkbox']:checked").length > 0) {
                CatalogPart += "&ct=";

                $("#ProductGroup input[type='checkbox']:checked").each(function (index) {
                    CatalogPart += $(this).val() + ",";
                });

                CatalogPart = CatalogPart.substring(0, CatalogPart.length - 1);
            }
        }
        else {
            if ($("#PID").val() !== undefined && $("#PID").val()!=="") {
                CatalogPart = "&ct=" + $("#PID").val();
            }

            if ($("#ProductGroup input[type='checkbox']:checked").length > 0) {
                CatalogPart = "&ct=";

                $("#ProductGroup input[type='checkbox']:checked").each(function (index) {
                    CatalogPart += $(this).val() + ",";
                });
                // Checkbox'da seçili var ise ana katalog silinoyr bu sebepten burada tekrar klenmiştir.

                CatalogPart = CatalogPart.substring(0, CatalogPart.length - 1);
            }
        }

        if ($("#PgType").val() == "Brand") {
            var BrandIdPart = "&id=" + $("#BrandId").val();
            params += BrandIdPart;

            params+="&brandPg=1"
        }

        params += CatalogPart;

        var mainCatId = $("#PID").val(); // mevcut kategorinin ID'si
        if (mainCatId != undefined && mainCatId > 0) {
            var maintCatPart = "&MainCatalogID=" + mainCatId;
            params += maintCatPart;

        }

        // Departman Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedDepartment = "";
        $("#Departments li > input[type='checkbox']:checked").each(function (index) { // Seçili renkleri döndürür
            SelectedDepartment += $(this).val() + ",";
        });

        if (SelectedDepartment != "" && SelectedDepartment != null && SelectedDepartment != undefined) {
            params += "&dp=" + SelectedDepartment.substring(0, SelectedDepartment.length - 1); // Substring ile sondaki virgül silinir
        }
        // Departman Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Marka Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedBrand = "";
        $("#Brands li > input[type='checkbox']:checked").each(function (index) { // Seçili markaları döndürür
            SelectedBrand += $(this).val() + ",";
        });

        if (SelectedBrand != "" && SelectedBrand != null && SelectedBrand != undefined) {
            params += "&b=" + SelectedBrand.substring(0, SelectedBrand.length - 1); // Substring ile sondaki virgül silinir
        }
        // Marka Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Sezon Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedSeason = "";
        $("#Seasons li > input[type='checkbox']:checked").each(function (index) { // Seçili renkleri döndürür
            SelectedSeason += $(this).val() + ",";
        });

        if (SelectedSeason != "" && SelectedSeason != null && SelectedSeason != undefined) {
            params += "&sea=" + SelectedSeason.substring(0, SelectedSeason.length - 1); // Substring ile sondaki virgül silinir
        }
        // Sezon Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Cookide kayıtlı grid değeri varsa onu ekler
        cookieGrid = $.cookie("OSgridCookie");
        if (cookieGrid != null && cookieGrid != "" && cookieGrid != undefined) {
            params += "&g=" + cookieGrid;
        }
        // Cookide kayıtlı grid değeri varsa onu ekler

        // Tükenenleri Gizle Seçeneğini Kontrol Eder
        var SoldOut = $("#SoldOutOp li input").val();
        if (SoldOut == "1") {
            params += "&so=" + SoldOut;
        }
        // Tükenenleri Gizle Seçeneğini Kontrol Eder

        // Sıralama Seçeneğini Kontrol Eder
        $PrcSort = $("#PrdSort > li > label.checked");

        if (isMobileResolution()) {
            $PrcSort = $("#PrdSortMobile > li > label.checked");
        }

        var SelectedSortID = $PrcSort.parent().children("input").val();
        if (SelectedSortID != null && SelectedSortID != "" && SelectedSortID != undefined) {
            params += "&o=" + SelectedSortID;
        }
        // Sıralama Seçeneğini Kontrol Eder

        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedColors = "";
        $("#Colors li > input[type='checkbox']:checked").each(function (index) { // Seçili renkleri döndürür
            SelectedColors += $(this).val() + ",";
        });

        if (SelectedColors != "" && SelectedColors != null && SelectedColors != undefined) {
            params += "&c=" + SelectedColors.substring(0, SelectedColors.length - 1); // Substring ile sondaki virgül silinir
        }
        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedSizes = "";
        $("#Sizes li > input[type='checkbox']:checked").each(function (index) { // Seçili bedenleri döndürür
            SelectedSizes += $(this).val() + ",";
        });

        if (SelectedSizes != "" && SelectedSizes != null && SelectedSizes != undefined) {
            params += "&s=" + SelectedSizes.substring(0, SelectedSizes.length - 1); // Substring ile sondaki virgül silinir
        }
        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedProperties = "";
        $("#Properties li > input[type='checkbox']:checked").each(function (index) { // Seçili özellikleri döndürür
            SelectedProperties += $(this).val() + ",";
        });

        if (SelectedProperties != "" && SelectedProperties != null && SelectedProperties != undefined) {
            params += "&prp=" + SelectedProperties.substring(0, SelectedProperties.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Kumaş Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedCloth = "";
        $("#Cloth li > input[type='checkbox']:checked").each(function (index) { // Seçili bedenleri döndürür
            SelectedCloth += $(this).val() + ",";
        });

        if (SelectedCloth != "" && SelectedCloth != null && SelectedCloth != undefined) {
            params += "&clh=" + SelectedCloth.substring(0, SelectedCloth.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        //Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var newPrices = "-1";
        var defaultPrices = $("#MinPrice").val() + "-" + $("#MaxPrice").val();

        if ($("#minPrc").val() !== undefined && $("#maxPrc").val() !== undefined) {
            newPrices = $("#minPrc").val() + "-" + $("#maxPrc").val();
        }

        params += "&prc=" + newPrices;

        if (newPrices!="-1" && newPrices != defaultPrices) {
            params+="&prcFilter=1"
        }

        //if ($("#minPrc").val() !== undefined && $("#maxPrc").val() !== undefined) {
        //    var newPrices = $("#minPrc").val() + "-" + $("#maxPrc").val();

        //    params += "&prc=" + newPrices;
        //}
        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
    }

    return params;
}

function SetUrl(params) {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var newURL = location.pathname + "?" + params;

    if (ios == false) {
        window.history.replaceState({}, "", newURL); // Sayfa URL'inin değişmesini sağlar
    }
    else {
        history.pushState({}, "", newURL);
    }
}

// Sayfalama İşleminden Önce URL History Oluşturur
function GenerateUrlHistoy() {

    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // Var olan QueryString'i okur
    var PathName = window.location.pathname; // Bulunan kataloğun url'ini alır
    var CurrentURL = "";

    if (getQueryFilter.indexOf("=") != "-1") {
        CurrentURL = PathName + "?" + getQueryFilter;
    }
    else {
        CurrentURL = PathName;
    }

    if (CurrentURL != null && CurrentURL != "" && CurrentURL != undefined) {
        window.history.pushState('', '', CurrentURL);
    }
}

// Sayfalar Arası Gezerken Browser Back/Prev Butonlarını Kontrol Eder
function BrowserBackAndPrevButtonControl() {
    $(window).on('popstate', function (event) {

        var vars = [], hash;
        var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        var IsCatalogFirsPage = true;

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                getPageByPageNo(hash[1], "true");
                IsCatalogFirsPage = false;
            }
        }

        if (IsCatalogFirsPage == true) {
            getPageByPageNo(1, "true");
        }

    });
}

// Seçili Filtreleri Ekler
function GetSelectedFilter() {
    $SelectedFilterBody = $(".SelectedFilter .SelectedFilterBody ul");
    $SelectedFilterBody.html("");

    var Color = getStandartMessages("Renk");
    var Size = getStandartMessages("Beden");
    var Price = getStandartMessages("Fiyat");
    var Propertie = getStandartMessages("Ozellik");
    var Cloth = getStandartMessages("Kumas");
    var ProductGroup = getStandartMessages("Kategori");
    var Department = getStandartMessages("Departman");
    var Brand = getStandartMessages("Marka");
    var Season = getStandartMessages("Sezon");

    // Ürün Grubu Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#ProductGroup li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li title='" + $(this).children("input").attr("data-rel") + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='ProductGroup'></span>";
        $li += "<span class='SelectedFilterTitle'>" /*+ ProductGroup */ + "</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Ürün Grubu Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Departman Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Departments li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li title='" + $(this).children("input").attr("data-rel") + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='Department'></span>";
        $li += "<span class='SelectedFilterTitle'>" /*+ Department*/ + "</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Departman Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Marka Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Brands li.selected").each(function (index) { // Seçili renkleri döndürür
        $li = "<li title='" + $(this).children("input").attr("data-rel") + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='Brand'></span>";
        $li += "<span class='SelectedFilterTitle'>" /*+ Brand */ + "</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Marka Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Sezon Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Seasons li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li title='" + $(this).children("input").attr("data-rel") + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='Season'></span>";
        $li += "<span class='SelectedFilterTitle'>" /*+ Season */ + "</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Sezon Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li title='" + $(this).children("input").attr("data-rel") + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='color'></span>";
        $li += "<span class='SelectedFilterTitle'>" /*+ Color */ + "</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li title='" + $(this).children("input").attr("data-rel") + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='size'></span>";
        $li += "<span class='SelectedFilterTitle'>" /*+ Size */ + "</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Özellik Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Properties li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li title='" + $(this).children("input").attr("data-rel") + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='properties'></span>";
        $li += "<span class='SelectedFilterTitle'>" /*+ Propertie */ + "</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Özellik Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Kumaş Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li title='" + $(this).children("input").attr("data-rel") + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='cloth'><</span>";
        $li += "<span class='SelectedFilterTitle'>" /*+ Cloth */ + "</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Kumaş Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $PriceSlide = $("#SliderValue").val();
    var newPrices = $("#MinPrice").val() + "-" + $("#MaxPrice").val();
    var defaultPrices = $("#MinPrice").val() + "-" + $("#MaxPrice").val();

    if ($("#minPrc").val() && $("#maxPrc").val()) {
        newPrices = $("#minPrc").val() + "-" + $("#maxPrc").val();
    }

    if (newPrices != defaultPrices) {
        $li = "<li title='" + $PriceSlide + "'>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $PriceSlide + "' data-type='price'></span>";
        $li += "<span class='SelectedFilterTitle'>"/* + Price*/ + "</span> " + $PriceSlide;
        $li += "</li>";

        $SelectedFilterBody.append($li);
    }
    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler 

    if ($SelectedFilterBody.find("li").length > 0) {
        OpenCloseSelectedFilterArea("Up"); // Filtre seçiliyse Seçili Filtreler alanını açar
    }
    else {
        OpenCloseSelectedFilterArea("Down"); // Filtre seçili değilse Seçili Filtreler alanını kapatır
    }
}

// Seçili Filtreleri Kaldıran Fonksiyon
function ClearSelectedFilter($selectedVal, $selectedType) {
    var selectedVal = $selectedVal;
    var selectedType = $selectedType;

    if (selectedVal != null && selectedVal != "" && selectedVal != undefined && selectedType != null && selectedType != "" && selectedType != undefined) {
        if (selectedType == "color") { // Filtre alanındaki seçili Color fitresini kaldırır
            $("#Colors li input[value='" + selectedVal + "']").removeAttr("checked");
            //$("#Colors li label[for='c-" + selectedVal + "']").removeClass("c_on");
            //$("#Colors li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "ProductGroup") { // Filtre alanındaki seçili Ürün Grubu fitresini kaldırır
            $("#ProductGroup li input[value='" + selectedVal + "']").removeAttr("checked");
            //$("#ProductGroup li label[for='ct-" + selectedVal + "']").removeClass("c_on");
            //$("#ProductGroup li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "Department") { // Filtre alanındaki seçili Departman fitresini kaldırır
            $("#Departments li input[value='" + selectedVal + "']").removeAttr("checked");
            //$("#Departments li label[for='dp-" + selectedVal + "']").removeClass("c_on");
            //$("#Departments li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "Brand") { // Filtre alanındaki seçili Marka fitresini kaldırır
            $("#Brands li input[value='" + selectedVal + "']").removeAttr("checked");
            //$("#Brands li label[for='b-" + selectedVal + "']").removeClass("c_on");
            //$("#Brands li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "Season") { // Filtre alanındaki seçili Sezon fitresini kaldırır
            $("#Seasons li input[value='" + selectedVal + "']").removeAttr("checked");
            //$("#Seasons li label[for='sea-" + selectedVal + "']").removeClass("c_on");
            //$("#Seasons li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "size") { // Filtre alanındaki seçili Size fitresini kaldırır
            $("#Sizes li input[value='" + selectedVal + "']").removeAttr("checked");
            //$("#Sizes li label[for='s-" + selectedVal + "']").removeClass("c_on");
            //$("#Sizes li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "properties") { // Filtre alanındaki seçili Özellik fitresini kaldırır
            $("#Properties li input[value='" + selectedVal + "']").removeAttr("checked");
            //$("#Properties li label[for='s-" + selectedVal + "']").removeClass("c_on");
            //$("#Properties li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "cloth") { // Filtre alanındaki seçili Kumaş fitresini kaldırır
            $("#Cloth li input[value='" + selectedVal + "']").removeAttr("checked");
            //$("#Cloth li label[for='s-" + selectedVal + "']").removeClass("c_on");
            //$("#Cloth li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "price") { // Filtre alanındaki seçili Price fitresini kaldırır
            $("#minPrc").val($("#MinPrice").val());
            $("#maxPrc").val($("#MaxPrice").val());
            $("#SliderValue").val($("#MinPrice").val() + '-' + $("#MaxPrice").val());

            var slider = document.getElementById('PriceSlider');
            if (slider != null)
                slider.noUiSlider.reset();

            GetPageByFilter();
        }
    }
}

// Tüm Filtreleri Kaldıran Fonksiyon
function ClearAllFilter($IsReload) {

    // Color filtrelerini kaldırır
    $("#Colors li input").removeAttr("checked");
    //$("#Colors li label").removeClass("c_on");
    //$("#Colors li input").parent("li").removeClass("selected");

    // Ürün Grubu filtrelerini kaldırır
    $("#ProductGroup li input").removeAttr("checked");
    //$("#ProductGroup li label").removeClass("c_on");
    //$("#ProductGroup li input").parent("li").removeClass("selected");

    // Departman filtrelerini kaldırır
    $("#Departments li input").removeAttr("checked");
    //$("#Departments li label").removeClass("c_on");
    //$("#Departments li input").parent("li").removeClass("selected");

    // Marka filtrelerini kaldırır
    $("#Brands li input").removeAttr("checked");
    //$("#Brands li label").removeClass("c_on");
    //$("#Brands li input").parent("li").removeClass("selected");

    // Sezon filtrelerini kaldırır
    $("#Seasons li input").removeAttr("checked");
    //$("#Seasons li label").removeClass("c_on");
    //$("#Seasons li input").parent("li").removeClass("selected");

    // Size filtrelerini kaldırır
    $("#Sizes li input").removeAttr("checked");
    //$("#Sizes li label").removeClass("c_on");
    //$("#Sizes li input").parent("li").removeClass("selected");

    // Özellik filtrelerini kaldırır
    $("#Properties li input").removeAttr("checked");
    //$("#Properties li label").removeClass("c_on");
    //$("#Properties li input").parent("li").removeClass("selected");

    // Kumaş filtrelerini kaldırır
    $("#Cloth li input").removeAttr("checked");
    //$("#Cloth li label").removeClass("c_on");
    //$("#Cloth li input").parent("li").removeClass("selected");

    // Price filtresini kaldırır
    //$("#MinPrice").val("0");
    //$("#MaxPrice").val("500");
    //$("#SliderValue").val("0-500");
    $("#SliderValue").val($("#MinPrice").val() + '-' + $("#MaxPrice").val());

    var slider = document.getElementById('PriceSlider');

    if (slider != null)
        slider.noUiSlider.reset();
    else {
        $('#minPrc').val($("#MinPrice").val());
        $('#maxPrc').val($("#MaxPrice").val());
    }

    if ($IsReload == "true") {
        GetPageByFilter(); // Filtreleri temizledikten sonra istek yapar
    }
}

// Mobil Filtre ve Sıralama Alanını Aldığı Değere Göre Açıp/Kapatan Fonksiyon
function MobilSortFilterAreaOpenOrClose($AreaName) {
    if ($AreaName != null && $AreaName != "" && $AreaName != undefined) {

        if ($AreaName == ".MobilSortArea") {
            $($AreaName).slideToggle("normal");
            $(".backdrop").toggleClass("openFilter");
        }
        else {
            $(".MobilSortArea").slideUp("normal", function () {
                $($AreaName).toggleClass("open");
                $(".backdrop").removeClass("openFilter");
                $(".backdrop").toggleClass("rightMenu");
            });
        }
    }
}

function GetFilteredFilter(param, callback) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/Home/GetFilteredFilter",
        data: param,
        cache: false,
        success: function (data) {
            callback(data);
        }
    });
}